export enum LvfLoginIdentifierType {
  UNKNOWN = 0,
  EMAIL = 1,
  PHONE = 2
}
